<script>
    import { onMount } from "svelte";
    import { db } from "../../Database.svelte";
    import FrameworkReference from '../../Models/frameworkReferenceModel';
    import Loader from '../Loader.svelte';

    export let reference;
    export let cancelAction;

    // suppress runtime warning
    export let saveAction;
    export let deleteAction;


    let referenceData;
    let sortFields;

    onMount(async () => {
        let parts = reference.reference_id.split(":");
        let framework_id = `${parts[0]}:${parts[1]}`;
        let fields = await FrameworkReference.getFields(framework_id);

        referenceData = await db.get(reference.reference_id);
        sortFields = FrameworkReference.parseReferenceFields(fields).sortFields;
    })
</script>

<Loader loading={!sortFields}>
    <div class="modal is-active">
        <div class="modal-background" on:click={cancelAction}></div>
        <div class="modal-card is-fullwidth">
            <header class="modal-card-head">
                <p class="modal-card-title">Reference</p>
                <button class="delete" aria-label="close" on:click={cancelAction}></button>
            </header>
            <section class="modal-card-body">
                <table class="table is-striped is-fullwidth">
                    <tbody>
                        {#each sortFields as field}
                            <tr>
                                <th>{field.label}</th>
                                <td>{referenceData[field.field]}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </section>
        </div>
    </div>
</Loader>

<style>
    .modal-card {
        width: 500px;
    }
</style>